import React, { useEffect } from 'react'
import { RouteComponentProps, useParams } from 'react-router'

import useMyhouse from '@Hooks/myhouse/useMyhouse'
import NoticeList from '@Components/templates/MyhouseNoticeListPage'
import useNotice from '@Hooks/myhouse/notice/useNotice'
import { MY_HOUSE_NOTICE_CATEGORY } from '@Root/contants/myhouse'
import useBoard from '@Hooks/myhouse/board/useBoard'
import { getParameterByName } from '@Root/utils/routeUtils'
import { getDeniedPath, LAND_DENIED_TYPE } from '@Root/contants/myhouseError'

function NoticeListPage(props: RouteComponentProps<any>) {
  const params = useParams<{ complexNo: string }>()

  const complexNo = parseInt(params.complexNo)

  const { setComplexNo, isLoaded } = useMyhouse()
  const { getNoticesReadableComplexNo } = useBoard()

  const category = getParameterByName('category')?.toUpperCase()
  const { setNoticeCategory } = useNotice()

  if (!complexNo) {
    props.history.replace(getDeniedPath(LAND_DENIED_TYPE.BBS_NOT_INCLUDE_COMPLEX_NO))
  }

  useEffect(() => {
    if (category && Object.values(MY_HOUSE_NOTICE_CATEGORY).includes(category as MY_HOUSE_NOTICE_CATEGORY)) {
      setNoticeCategory(category as MY_HOUSE_NOTICE_CATEGORY)
    } else {
      setNoticeCategory(MY_HOUSE_NOTICE_CATEGORY.ALL)
    }
  }, [category])

  useEffect(() => {
    setComplexNo(complexNo)
  }, [complexNo])

  useEffect(() => {
    // 읽기 권한이 없는 경우
    if (isLoaded && !getNoticesReadableComplexNo(complexNo)) {
      if (props.history.length > 1) {
        props.history.goBack()
      } else {
        props.history.push(getDeniedPath(LAND_DENIED_TYPE.BBS_NOT_AUTH_COMPLEX))
      }
    }
  }, [isLoaded])

  return <>{getNoticesReadableComplexNo(complexNo) && <NoticeList />}</>
}
export default NoticeListPage
